export default "__VITE_ASSET__e43404d7__"